var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hr pt20"},[_c('ul',{staticClass:"bannerList"},_vm._l((_vm.bannerList),function(banner,index){return _c('li',{key:index},[_c('a',{on:{"click":function($event){return _vm.goBannerPage(banner.bannerUrl)}}},[_c('span',{staticClass:"img"},[_c('img',{attrs:{"src":banner.imgURL,"alt":banner.bannerName}})])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }